import { Outlet, useRouterState } from "@tanstack/react-router";
import { AnimatePresence, motion } from "framer-motion";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FiltersRow } from "@/components/filters/FiltersRow";
import { TabsNav } from "@/components/tabs/TabsNav";
import { pageTransition } from "@/lib/motion";

/** Page shell — wraps the header, the global filter row, the tabs
 * navigation, and the active tab content. The root route mounts this
 * so every /tabs/* page shares the chrome without re-mounting it.
 *
 * The active <Outlet /> is wrapped in <AnimatePresence mode="wait">
 * so each tab change fades/slides the content without re-rendering
 * the surrounding chrome. Reduced-motion users bypass this entirely
 * thanks to <MotionConfig reducedMotion="user"> in the root layout. */
export function Shell() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <div className="mx-auto max-w-[1400px] px-8 pb-12 pt-4">
      <Header />
      <FiltersRow />
      <TabsNav />
      <main className="mt-6">
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={pathname}
            variants={pageTransition}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  );
}
